"use strict";

var _interopRequireDefault = require("C:/Users/sandy/Desktop/EIOSYS/Admin/Alembic-Grow-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.notificationSubMenu = void 0;
var _interopRequireWildcard2 = _interopRequireDefault(require("C:/Users/sandy/Desktop/EIOSYS/Admin/Alembic-Grow-Admin/node_modules/@babel/runtime/helpers/interopRequireWildcard.js"));
const notificationSubMenu = exports.notificationSubMenu = [{
  path: '/notifications/list',
  component: () => Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require('@/views/notifications/list.vue'))),
  name: 'Announcements',
  meta: {
    title: 'notifications.title',
    // roles: ['superadmin', 'admin', 'executive'],
    noCache: true,
    icon: 'guide',
    activeMenu: '/notifications/list'
  }
}, {
  path: '/notifications/add',
  component: () => Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require('@/views/notifications/manage.vue'))),
  name: 'Add',
  props: {
    isEdit: false
  },
  meta: {
    title: 'notifications.manage',
    // roles: ['superadmin'],
    noCache: true,
    hidden: true,
    activeMenu: '/notifications/list'
  }
}, {
  path: '/notifications/edit/:id(\\d+)',
  component: () => Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require('@/views/notifications/manage.vue'))),
  name: 'Edit',
  props: {
    isEdit: true
  },
  meta: {
    title: 'notifications.manage',
    // roles: ['superadmin'],
    noCache: true,
    hidden: true,
    activeMenu: '/notications/list'
  }
}, {
  path: '/notifications/resend/:id(\\d+)',
  component: () => Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require('@/views/notifications/manage.vue'))),
  name: 'Resend',
  props: {
    isEdit: true
  },
  meta: {
    title: 'notifications.manage',
    noCache: true,
    activeMenu: '/notifications/list',
    hidden: true
  }
}];